let xlsxPromise = null;
let tesseractPromise = null;
let html2CanvasPromise = null;

export function loadXlsx() {
  if (!xlsxPromise) {
    xlsxPromise = import("xlsx")
      .then((module) => (module?.utils ? module : module.default))
      .catch((error) => {
        xlsxPromise = null;
        throw error;
      });
  }
  return xlsxPromise;
}

export function loadTesseract() {
  if (!tesseractPromise) {
    tesseractPromise = import("tesseract.js")
      .then((module) => module.default || module)
      .catch((error) => {
        tesseractPromise = null;
        throw error;
      });
  }
  return tesseractPromise;
}

export function loadHtml2Canvas() {
  if (!html2CanvasPromise) {
    html2CanvasPromise = import("html2canvas")
      .then((module) => module.default || module)
      .catch((error) => {
        html2CanvasPromise = null;
        throw error;
      });
  }
  return html2CanvasPromise;
}
